/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';

const GoogleMapsEmbed = () => (
  <div className="mapouter">
    <div className="gmap_canvas">
      <iframe
        className="gmap_iframe"
        width="100%"
        height="592"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://maps.google.com/maps?width=385&amp;height=490&amp;hl=en&amp;q=27-33 Piper Lane, East Bendigo VIC, Australia&amp;t=&amp;z=8&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        allowFullScreen
         />
    </div>
  </div>
);

export default GoogleMapsEmbed;
